import { useMemo } from 'react';
import { getDefaultCountry } from './utils';
export const useDefaultCountry = (phoneNumber) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const defaultCountry = useMemo(() => getDefaultCountry(phoneNumber), []);
    return defaultCountry;
};
